"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _get = _interopRequireDefault(require("./get"));

var _valueArray = _interopRequireDefault(require("./valueArray"));

var _pipe = _interopRequireDefault(require("./util/pipe"));

var _default = (0, _unmutable.default)({
  name: 'last',
  immutable: 'last',
  array: function array() {
    return (0, _get.default)(-1);
  },
  all: function all() {
    return (0, _pipe.default)((0, _valueArray.default)(), (0, _get.default)(-1));
  }
});

exports.default = _default;